"use strict";
import { DisplayNameType } from "features/accounts/types";
import { useOnchainDisplayName } from "features/accounts/useOnchainDisplayName";
import { shortenAddress } from "utilities/src/addresses";
export function useWalletDisplay(walletAddress) {
  const displayName = useOnchainDisplayName(walletAddress, {
    showShortenedEns: true,
    includeUnitagSuffix: true
  });
  return {
    displayName: displayName?.name ?? shortenAddress(walletAddress),
    showUnitagIcon: displayName?.type === DisplayNameType.Unitag,
    showShortAddress: displayName?.type === DisplayNameType.Unitag || displayName?.type === DisplayNameType.ENS,
    shortAddress: shortenAddress(walletAddress)
  };
}
